export const DEFAULT_HEADING_TEXT = "The future of everything";
export const DEFAULT_SUBHEADING_TEXT =
  "Get ready for five days of disruptive ideas and ground-breaking insights as we bring together the most revolutionary minds and reflect on what our world will look like fifty years from now.";
export const DEFAULT_BUTTON_TEXT = "Register";
